// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1LoAQ","termAndConditionsTextWrapper":"styles_termAndConditionsTextWrapper__32OHC","termAndConditionsText":"styles_termAndConditionsText__NXwQi"};